import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  clear,
  decryptData,
  encryptData,
  removeItem,
  setItem,
  Storage,
} from "../Services/Storage";
import { Axios } from "../Services/Axios";
import { toast } from "react-toastify";
import { FiLogOut } from "react-icons/fi";

export const adminModules = [
  { name: "Cities", link: "/Cities" },
  { name: "Centers", link: "/centers" },
  { name: "Course Inquiry", link: "/course-inquiry" },
  { name: "Placements", link: "/placements" },
  { name: "POM", link: "/Pom" },
  { name: "SOM", link: "/Som" },
  { name: "Upcoming Batches", link: "/upcoming-batches" },
  { name: "Events", link: "/events" },
  { name: "Tickets", link: "/tickets" },
  { name: "Issues", link: "/issues" },
  { name: "Statuses", link: "/statuses" },
  { name: "Courses", link: "/courses" },
  { name: "Semester", link: "/semester" },
  { name: "Books", link: "/oms" },
  { name: "Orders", link: "/orders" },
  { name: "Settings", link: "/Settings" },
  { name: "Passes", link: "/Passes" },
  { name: "Verification", link: "/verification" }
];

export const userModules = [
  { name: "Course Inquiry", link: "/course-inquiry" },
  { name: "Placements", link: "/placements" },
  { name: "POM", link: "/Pom" },
  { name: "SOM", link: "/Som" },
  { name: "Upcoming Batches", link: "/upcoming-batches" },
  { name: "Events", link: "/events" },
  { name: "Tickets", link: "/tickets" },
  { name: "ECM order", link: "/oms-center" },
  { name: "Ordered", link: "/orders" },
  { name: "Settings", link: "/Settings" },

];

export const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [centers, setCenters] = React.useState([]);
  const [userPermissions, setUserPermissions] = React.useState(
    Storage.getItem("user").permissions
  );
  const [cc, SetCC] = React.useState("");
  const [center, setCenter] = React.useState(null);

  const [init, setInit] = React.useState(true);
  const xt = useSelector((e) => e.Center);
  const role = decryptData(useSelector((e) => e.Role));
  const id = Storage.getItem("user").id;

  const Logout = () => {
    clear();
    dispatch({ type: "setLogin", payload: encryptData(false) });
    dispatch({ type: "setUser", payload: null });
    dispatch({ type: "setRole", payload: null });
    dispatch({ type: "setCenter", payload: null });
    dispatch({ type: "setOpenSettings", payload: null });

    navigate("/login");
  };
  const openSettings = (val) => {
    dispatch({ type: "setOpenSettings", payload: encryptData(val) });
  };
  const links = [
    { to: "/", text: "Dashboard" },
    { to: "/inquiry", text: "Course Inquiry" },
    { to: "/centers", text: "Centers" },
    // { to: "/batches", text: "Upcoming Batches" },
    // { to: "/som", text: "Student of the Month" },
    // { to: "/pom", text: "Project of the Month" },
    // { to: "/placement", text: "Placements" },
    // { to: "/events", text: "Center Events" },
    // { to: "/survey", text: "Survey" },
    // { to: "/complaint", text: "Complain" },
  ];

  React.useEffect(() => {
    if (center) {
      SetCC(center.id);
    }
    if (role.role === "admin") {
      GetCenters();
    }
  }, [center]);

  React.useEffect(() => {
    if (xt) {
      setCenter(decryptData(xt));
    }
  }, [xt]);
  React.useEffect(() => {
    const nc = centers.find((x) => x.id === cc);
    if (nc) {
      dispatch({ type: "setCenter", payload: encryptData(nc) });
      setItem("center", nc);
    } else if (cc === "admin") {
      dispatch({ type: "setCenter", payload: null });
      removeItem("center");
    }
  }, [cc]);

  React.useEffect(() => {
    fetchPermissions(id)
      .then((res) => {
        console.log(res, "res");
        setUserPermissions(res);
      })
      .catch((err) => toast.error("Error"));
  }, []);

  const GetCenters = () => {
    Axios.get("/Centres/GetAll").then((res) => {
      setCenters(res.data);
    });
  };
  return (
    <div className="w-[260px] h-screen bg-[#1a1c23] text-white flex flex-col fixed left-0 top-0 z-40 transition-all duration-500 shadow-2xl border-r border-gray-800/50 font-[Poppins]">
      <div className="p-6 border-b border-gray-800/50 flex flex-col items-center justify-center h-[100px] bg-[#14151a]">
        <img src={process.env.PUBLIC_URL + "/white-logo.png"} alt="MAAC Dashboard" className="max-h-18 drop-shadow-lg" />
      </div>

      <div className="flex-1 overflow-y-auto py-6 px-4 space-y-2 scrollbar-thin scrollbar-thumb-gray-700">
        <div className="mb-4 px-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Main Menu
        </div>

        {role.role == "admin"
          ? userPermissions.map((item, i) =>
            item.canView ? (
              <NavLink
                to={`${item.title === "Books"
                  ? "oms"
                  : item.title.replace(/ /g, "-").toLowerCase()
                  }`}
                className={({ isActive }) =>
                  `flex items-center px-4 py-2.5 rounded-xl transition-all duration-200 mb-1 text-sm ${isActive
                    ? "bg-red-500/10 text-red-500 font-medium"
                    : "text-gray-400 hover:bg-gray-800/50 hover:text-white"
                  }`
                }
                key={i}
              >
                {item.title}
              </NavLink>
            ) : null
          )
          : userPermissions.map((item, i) =>
            item.canView ? (
              <NavLink
                to={`${item.title === "ECM order"
                  ? "oms-center"
                  : item.title === "Ordered"
                    ? "orders"
                    : item.title.replace(/ /g, "-").toLowerCase()
                  }`}
                className={({ isActive }) =>
                  `flex items-center px-4 py-2.5 rounded-xl transition-all duration-200 mb-1 text-sm ${isActive
                    ? "bg-red-500/10 text-red-500 font-medium"
                    : "text-gray-400 hover:bg-gray-800/50 hover:text-white"
                  }`
                }
                key={i}
              >
                {item.title}
              </NavLink>
            ) : null
          )}
      </div>

      <div className="p-4 border-t border-gray-800/50 bg-[#14151a]">
        <button
          className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-800/50 hover:bg-red-500/10 text-gray-400 hover:text-red-500 text-sm rounded-xl transition-colors duration-200"
          onClick={Logout}
        >
          <FiLogOut /> Log out
        </button>
      </div>
    </div>
  );
};

export const fetchPermissions = (id) => {
  return Axios.get(`/Permissions/GetByUserId?Id=${id}`)
    .then((response) => response.data)
    .catch((error) => {
      toast.error("Error fetching permissions");
      throw error; // Re-throw the error to allow further handling if needed
    });
};
